import React from 'react';
import { BUILD_VS_BUY, getFooterSolutionLinks } from '../../../content/enterpriseMessaging';
import { BRAND } from '../../../content/staticAssets';
import './global.css';

const footerNav = {
  Solutions: getFooterSolutionLinks(),
  Company: [
    { name: 'About', href: '/company' },
    { name: 'Delivery', href: '/delivery' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Contact', href: '/contact' },
    { name: 'Updates', href: '/updates' },
  ],
  Legal: [{ name: 'Privacy Policy', href: '/privacy-policy' }],
};

export default function Footer() {
  return (
    <footer className="bg-surface border-t border-ink-200/50">
      <div className="container-x py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <a href="/" className="block min-w-0 max-w-full">
              <img
                alt="MyOrgLab"
                src={BRAND.logoTransparent}
                className="h-28 w-auto max-w-full"
              />
            </a>
            <p className="text-sm text-ink-600 leading-relaxed max-w-xs">
              {BUILD_VS_BUY.body}
            </p>
          </div>
          <div className="md:col-span-8 grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6 md:pt-[7.5rem]">
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500">Solutions</h2>
              <ul className="mt-4 space-y-2">
                {footerNav.Solutions.map((l) => (
                  <li key={l.name}>
                    <a
                      href={l.href}
                      className="text-sm text-ink-700 hover:text-brand-600 transition-colors"
                    >
                      {String(l.name || '').replace(/\u2122/g, '').replace(/™/g, '').trim()}
                      {l.featured ? <sup className="ml-0.5 text-[9px]">™</sup> : null}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500">Company</h2>
              <ul className="mt-4 space-y-2">
                {footerNav.Company.map((l) => (
                  <li key={l.name}>
                    <a
                      href={l.href}
                      className="text-sm text-ink-700 hover:text-brand-600 transition-colors"
                    >
                      {l.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500">Legal</h2>
              <ul className="mt-4 space-y-2">
                {footerNav.Legal.map((l) => (
                  <li key={l.name}>
                    <a
                      href={l.href}
                      className="text-sm text-ink-700 hover:text-brand-600 transition-colors"
                    >
                      {l.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-ink-200 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-ink-500">
            &copy; {new Date().getFullYear()} MyOrgLab. All rights reserved.
          </p>
          <p className="text-xs text-ink-400">
            Platform partners for enterprise analytics, semantic intelligence, and AI.
          </p>
        </div>
      </div>
    </footer>
  );
}
